import { render, staticRenderFns } from "./eq_notice.vue?vue&type=template&id=0c66879e"
import script from "./eq_notice.vue?vue&type=script&lang=js"
export * from "./eq_notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports